module.exports = __webpack_public_path__ + "static/media/css.fa811f6b.png";